import React from 'react';
import { useSearchParams } from 'react-router-dom';
import ClickListPage from '../components/ClickListPage';
import { Segmented } from '../components/ui';

// Lượt click 3 sàn: cùng bảng user_orders, phân biệt bằng cột platform
const CONFIGS = {
  all: {
    label: 'Tất cả',
    endpoint: '/admin/affiliate-clicks',
    platform: 'all',
    queryKey: 'all-clicks',
    allowDelete: false,
    showProduct: true,
    idFields: [
      { param: 'subid', label: 'Sub ID' },
      { param: 'item_id', label: 'Item / Product ID' }
    ],
    detailFields: [
      { key: 'id', label: 'Click ID', mono: true },
      { key: 'product_name', label: 'Sản phẩm' },
      { key: 'shop_name', label: 'Shop' },
      { key: 'subid', label: 'Sub ID', mono: true },
      { key: 'item_id', label: 'Item / Product ID', mono: true },
      { key: 'original_link', label: 'Link gốc', link: true },
      { key: 'shortlink', label: 'Shortlink', link: true }
    ]
  },
  // Shopee: id được gắn vào affiliate sub-id để cron ghép đơn về user
  shopee: {
    label: 'Shopee',
    endpoint: '/admin/affiliate-clicks',
    platform: 'shopee',
    queryKey: 'user-orders',
    allowDelete: true,
    showProduct: false,
    idFields: [
      { param: 'subid', label: 'Sub ID' },
      { param: 'item_id', label: 'Item ID' }
    ],
    detailFields: [
      { key: 'id', label: 'User order ID', mono: true },
      { key: 'subid', label: 'Sub ID', mono: true },
      { key: 'item_id', label: 'Item ID', mono: true },
      { key: 'shortlink', label: 'Shortlink', link: true }
    ]
  },
  lazada: {
    label: 'Lazada',
    endpoint: '/admin/affiliate-clicks',
    platform: 'lazada',
    queryKey: 'lazada-user-orders',
    allowDelete: false,
    showProduct: true,
    idFields: [
      { param: 'subid', label: 'Sub ID' },
      { param: 'item_id', label: 'Item ID' },
      { param: 'sku_id', label: 'SKU ID' },
      { param: 'offer_id', label: 'Offer ID' }
    ],
    detailFields: [
      { key: 'product_name', label: 'Sản phẩm' },
      { key: 'shop_name', label: 'Shop' },
      { key: 'subid', label: 'Sub ID', mono: true },
      { key: 'item_id', label: 'Item ID', mono: true },
      { key: 'sku_id', label: 'SKU ID', mono: true },
      { key: 'offer_id', label: 'Offer ID', mono: true },
      { key: 'original_link', label: 'Link gốc', link: true },
      { key: 'shortlink', label: 'Shortlink', link: true }
    ]
  },
  tiktokshop: {
    label: 'TikTok Shop',
    endpoint: '/admin/affiliate-clicks',
    platform: 'tiktokshop',
    queryKey: 'tiktok-clicks',
    allowDelete: false,
    showProduct: true,
    idFields: [
      { param: 'click_id', label: 'Click ID' },
      { param: 'subid', label: 'Sub ID' },
      { param: 'product_id', label: 'Product ID' }
    ],
    detailFields: [
      { key: 'id', label: 'Click ID', mono: true },
      { key: 'user_id', label: 'User ID', mono: true },
      { key: 'shop_name', label: 'Shop' },
      { key: 'subid', label: 'Sub ID', mono: true },
      { key: 'product_id', label: 'Product ID', mono: true },
      { key: 'original_link', label: 'Link gốc', link: true },
      { key: 'shortlink', label: 'Link rút gọn', link: true },
      { key: 'full_link', label: 'Link affiliate đầy đủ', link: true },
      { key: 'request_key', label: 'Mã yêu cầu', mono: true },
      { key: 'client_platform', label: 'Nền tảng truy cập' },
      { key: 'client_version', label: 'Phiên bản ứng dụng' },
      { key: 'ip_address', label: 'Địa chỉ IP', mono: true },
      { key: 'referrer', label: 'Trang gửi yêu cầu' }
    ]
  }
};

const PLATFORM_OPTIONS = Object.values(CONFIGS).map((c) => ({ value: c.platform, label: c.label }));

const ClicksPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const platform = CONFIGS[searchParams.get('platform')] ? searchParams.get('platform') : 'all';
  const config = { ...CONFIGS[platform], title: 'Lượt click' };

  const tabs = (
    <Segmented
      className="mb-3"
      value={platform}
      onChange={(value) => setSearchParams({ platform: value }, { replace: true })}
      options={PLATFORM_OPTIONS}
    />
  );

  // key theo sàn để reset bộ lọc/trang/lựa chọn khi đổi sàn (mỗi sàn có bộ lọc mã khác nhau)
  return <ClickListPage key={platform} config={config} tabs={tabs} />;
};

export default ClicksPage;
